// import axios from 'axios'
import delay from 'lodash/delay'
import find from 'lodash/find'
import filter from 'lodash/filter'
import meanBy from 'lodash/meanBy'
import axios from 'axios'
import to from 'await-to-js'

import moment from 'moment'
import 'moment-recur'
/* global THREE */

const mockCategories = [
  {
    id: 1,
    label: 'Humanism/Culture',
    color: 0x925DE8
  },
  {
    id: 2,
    label: 'Education',
    color: 0x2B71E2
  },
  {
    id: 3,
    label: 'Politics',
    color: 0x48C4EF
  },
  {
    id: 4,
    label: 'Economy',
    color: 0xFF85CE
  },
  {
    id: 5,
    label: 'Science',
    color: 0xFF556A
  },
  {
    id: 6,
    label: 'Nature/Environment',
    color: 0xFF8E55
  },
  {
    id: 7,
    label: 'Technology',
    color: 0xFFBE2E
  },
  {
    id: 8,
    label: 'Medicine',
    color: 0x64E2BB
  }
]

const getMockInterestOverTime = function () {
  let ret = []
  // let l = 10 + Math.round(Math.random() * 20)

  let y = 2008 + Math.round(Math.random() * 8)
  let m = Math.round(Math.random() * 10)
  let d = 1 + Math.round(Math.random() * 27)
  let startDate = moment([y, m, d])
  let now = moment()
  let l = now.diff(startDate, 'months', true)

  let intervals = startDate.recur().dayOfMonth(1).next(l)
  let trend = 1

  for (let i = 0; i < l; i++) {
    let interest
    if (i === 0) {
      interest = Math.random()
    } else {
      let prev = ret[i - 1].interest
      interest = prev + ((Math.random() * 0.1) * trend)
      interest = Math.max(0, Math.min(1, interest))
    }
    if (interest === 1) trend = -1
    if (interest === 0) trend = 1
    // randomize trend every 2 months
    if (i % 2 === 0) {
      trend = Math.random() > 0.5 ? -1 : 1
    }

    ret.push({
      date: intervals[i].format(),
      interest
    })
  }

  // ret.push({
  //   date: now.format(), // now
  //   interest: Math.random()
  // })
  return ret
}
const regions = [
  'United States',
  'Zimbabwe',
  'Italy',
  'Japan',
  'France',
  'Germany',
  'Poland',
  'Brazil',
  'Argentina',
  'United Kingdom',
  'Indonesia',
  'Australia',
  'Afghanistan',
  'Ethiopia',
  'Hungary',
  'Portugal',
  'Vietnam'
]
const getMockInterestByRegion = function () {
  let ret = []
  for (let i = 0; i < 6; i++) {
    let name = regions[Math.floor(Math.random() * regions.length)]
    while (find(ret, {name})) { // avoid duplicates
      name = regions[Math.floor(Math.random() * regions.length)]
    }
    let interest = Math.random()
    ret.push({name, interest})
  }
  return ret
}

const RELATED_TOTEM_AMOUNT = 5

let conceptLabels = [
  [
    'Gender equality',
    'Women\'s rights',
    'Human rights',
    'Spiritual growth',
    'Art',
    'Journalism',
    'Feminism',
    'Religion',
    'Awakening movies'
  ],
  [
    'Knowledge sharing',
    'Olympic trophies',
    'Learning',
    'Education',
    'Lessons from history',
    'Litterature',
    'Media literacy',
    'Science and Technology',
    'Grad school',
    'Academies'
  ],
  [
    'Climate Policy',
    'Counter-Terrorism',
    'Free World',
    'Relaunch of USA influence',
    'Revive of Euro-mediterranean relationship',
    'Political Engagement',
    'Europe’s unity',
    'Privacy',
    'Ending Poverty',
    'Immigration'
  ],
  [
    'Economic system',
    'Social justice',
    'Economic growth',
    'New currencies',
    'Online trading',
    'Sustainable development',
    'Circular economy',
    'Basic income',
    'Cyber security'
  ],
  [
    'Scientific discoveries',
    'Extraterrestrial life',
    'Man on Mars',
    'New materials',
    'Molecular biology'
  ],
  [
    'Environment improvements',
    'Climate Change adaptation',
    'Preservation of life',
    'Renewable energy'
  ],
  [
    'Video-games evolution',
    'Technological breakthroughs',
    'Artificial Intelligence',
    'Cloud',
    'Blockchain technology',
    'Digital immersion',
    'Smart-Things',
    'Self-driving automobiles',
    'Solar powered facilities',
    'New means of transportation'
  ],
  [
    'Cancer treatments improvement',
    'Medical discovery',
    'Alternative medicine',
    'Drugs',
    'Homeopathy',
    'Phytoterapy',
    'Traditional Chinese medicine',
    'Acupunture',
    'Biomedical research'
  ]
]

const mockConcepts = []
let incrementalId = 0
conceptLabels.forEach((category, categoryIndex) => {
  category.forEach((concept) => {
    mockConcepts.push({
      id: incrementalId,
      category: categoryIndex + 1,
      activity: Math.random(),
      label: concept,
      interestOverTime: getMockInterestOverTime(),
      interestByRegion: getMockInterestByRegion()
    })
    incrementalId++
  })
})

const useMockBackend = false

class GoogleHopeService {
  constructor () {
    this.categoriesCache = null
    this.conceptsCache = null
    this.userTotem = null
    this.loading = false
    this.shareAvailable = false

    let location = window && window.location ? window.location.host : ''

    this._getCategories = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/categories' : '/api/categories',
      withCredentials: true
    }
    this._getConcepts = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/concepts' : '/api/concepts'
    }
    this._getRelatedTotems = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/totems?amount=' + RELATED_TOTEM_AMOUNT : '/api/totems?amount=' + RELATED_TOTEM_AMOUNT
    }
    this._saveTotem = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/totem' : '/api/totem',
      method: 'POST'
    }
    this._saveThumbnail = {
      url: location.indexOf('google-hope-accurat') === -1 ? 'https://accurat-ghope.appspot.com/api/thumbnail' : '/api/thumbnail',
      method: 'PUT',
      config: {headers: {'Content-Type': 'multipart/form-data'}}
    }
  }

  // async
  // retrieves a list of categories
  // each one containing concepts
  getCategories () {
    this.loading = true
    if (!useMockBackend) {
      return new Promise(async (resolve, reject) => {
        let [error, response] = await to(axios.request(this._getCategories))
        this.loading = false
        if (error) {
          reject(error)
        } else {
          let data = response.data.map(cat => {
            cat.color = new THREE.Color(cat.color).getHex()
            return cat
          })
          this.categoriesCache = data
          resolve(data)
        }
      })
    }

    return new Promise((resolve, reject) => {
      // fake delay
      this.categoriesCache = mockCategories
      delay(() => {
        this.loading = false
        resolve(mockCategories)
      }, Math.random() * 1500)
    })
  }
  // async
  // retrieves a list of flattened concept
  // category optional
  // if category is omitted it returns all concepts of all categories
  getConcepts (categoryId = -1) {
    this.loading = true

    if (!useMockBackend) {
      return new Promise(async (resolve, reject) => {
        let [error, response] = await to(axios.request(this._getConcepts))
        this.loading = false
        if (error) {
          reject(error)
        } else {
          let userConcepts = response.data.map(concept => {
            let activity = concept.interest[concept.interest.length - 1].value / 100
            let beforeActivity = concept.interest[concept.interest.length - 2].value / 100
            let trend = activity > beforeActivity ? 1 : -1
            let concObject = {
              id: concept.id,
              category: concept.category,
              label: concept.label,
              link: concept.link,
              entity: concept.entity,
              activity
            }

            concObject.interestByRegion = concept.regions.map(region => {
              return {
                name: region.geoName,
                interest: region.value / 100
              }
            })
            concObject.interestOverTime = concept.interest.map(interest => {
              return {
                date: moment(interest.formattedAxisTime).format(),
                formattedDate: interest.formattedAxisTime,
                interest: interest.value / 100
              }
            })

            return Object.assign(concObject, {
              confirmed: false,
              importance: 0.5,
              trend,
              categoryObject: this.getConceptCategory(concept)
            })
          })
          this.conceptsCache = userConcepts
          if (categoryId !== -1) {
            resolve(filter(userConcepts, {category: categoryId}))
          } else {
            resolve(userConcepts)
          }
        }
      })
    }
    return new Promise((resolve, reject) => {
      this.conceptsCache = mockConcepts
      let userConcepts = mockConcepts.map(concept => {
        return Object.assign({}, concept, {
          confirmed: false,
          importance: 0.5,
          categoryObject: this.getConceptCategory(concept)
        })
      })
      if (categoryId !== -1) {
        // fake delay
        delay(() => {
          this.loading = false
          resolve(filter(userConcepts, {category: categoryId}))
        }, Math.random() * 1500)
      } else {
        // fake delay
        delay(() => {
          this.loading = false
          resolve(userConcepts)
        }, Math.random() * 1500)
      }
    })
  }
  // async
  // retrieves a list of related totems
  getRelatedTotems (concepts) {
    this.loading = true

    if (!useMockBackend) {
      return new Promise(async (resolve, reject) => {
        let [error, response] = await to(axios.request(this._getRelatedTotems))
        this.loading = false
        if (error) {
          reject(error)
        } else {
          // let data = response.data.map(cat => {
          //   cat.color = new THREE.Color(cat.color).getHex()
          //   return cat
          // })
          let res = []
          let data = response.data

          for (let i = 0; i < data.length; i++) {
            let totem = data[i]
            let concepts = []

            for (let j = 0; j < totem.concepts.length; j++) {
              let concept = this.conceptsCache[totem.concepts[j].id - 1]

              if (!concept) {
                continue
              }

              concept.importance = totem.concepts[j].importance
              concept.name = totem.name
              concept.latlon = totem.latlon

              concepts.push(concept)
            }

            res.push(concepts)
          }

          // this.categoriesCache = data
          resolve(res)
        }
      })
    }

    // this.loading = true
    // return new Promise((resolve, reject) => {
    //   let ret = []
    //   for (let i = 0; i < 5; i++) {
    //     let totem = []
    //     for (let k = 0; k < 10; k++) {
    //       let randomConcept = this.conceptsCache[Math.floor(Math.random() * (this.conceptsCache.length - 1))]
    //       // avoid creating duplicate concepts
    //       if (!find(totem, {id: randomConcept.id})) {
    //         totem.push(Object.assign({}, randomConcept, {
    //           categoryObject: this.getConceptCategory(randomConcept),
    //           importance: Math.random()
    //         }))
    //       }
    //     }
    //     ret.push(totem)
    //   }
    //   delay(() => {
    //     this.loading = false

    //     console.log('TOTEMS:', ret)
    //     resolve(ret)
    //   }, Math.random() * 1500)
    // })
  }

  // sync
  // returns a category given a concept
  getConceptCategory (concept) {
    return find(this.categoriesCache, {id: concept.category})
  }
  // sync
  // builds totem data based on selected concepts
  getTotemData (concepts) {
    if (!this.categoriesCache) {
      return null
    }
    let data = {
      stones: []
    }

    this.categoriesCache.forEach((category) => {
      let conc = filter(concepts, {category: category.id})
      if (conc.length > 0) {
        data.stones.push({
          id: category.id,
          color: category.color,
          label: category.label,
          averageActivity: meanBy(conc, 'activity'),
          concepts: conc
        })
      }
    })

    return data
  }

  // async
  // saves a totem
  saveTotem (concepts, name, location) {
    this.loading = true

    if (!useMockBackend) {
      return new Promise(async (resolve, reject) => {
        let request = Object.assign({
          data: {
            name,
            concepts: concepts.map(concept => { return {id: concept.id, importance: concept.importance} }),
            latlon: location.lat + ',' + location.lng
          }
        }, this._saveTotem)

        let [error, response] = await to(axios.request(request))
        this.loading = false
        if (error) {
          reject(error)
        } else {
          this.userTotem = this.getTotemData(concepts)
          this.userTotem.id = response.data.key
          this.userTotem.label = name
          this.userTotem.geolocation = location
          resolve(response)
        }
      })
    }

    return new Promise((resolve, reject) => {
      this.userTotem = this.getTotemData(concepts)
      this.userTotem.id = Math.round(Math.random() * 100000)
      this.userTotem.label = name
      this.userTotem.geolocation = location
      // fake delay
      delay(() => {
        this.loading = false
        resolve(this.userTotem)
      }, Math.random() * 1500)
    })
  }
  // async
  // saves a thumbnail
  saveThumbnail (id, thumbnail) {
    this.loading = true

    if (!useMockBackend) {
      return new Promise(async (resolve, reject) => {
        let data = new FormData()
        data.append('thumbnail', thumbnail)
        let request = Object.assign({data}, this._saveThumbnail)
        request.url += '/' + id

        let [error, response] = await to(axios.request(request))
        this.loading = false
        if (error) {
          reject(error)
        } else {
          this.shareAvailable = true
          resolve(response)
        }
      })
    }

    return new Promise((resolve, reject) => {
      // fake delay
      delay(() => {
        this.loading = false
        resolve(true)
      }, Math.random() * 1500)
    })
  }
}

export default new GoogleHopeService()



// WEBPACK FOOTER //
// ./src/services/GoogleHopeService.js